<template>
  <div>
    <ConfirmACHPayment
      class="pt-10"
      @open-edelivery="next"
      @display-warning="showWarning = true"
      v-if="isB2BillingForm"
    />
    <ConfirmDirectBillPayment
      class="pt-12"
      @open-edelivery="next"
      @display-warning="showWarning = true"
      v-if="isA1orC2orD2BillingForm"
    />
    <WarningDialog
      class="pt-12"
      v-if="showWarning"
      @hide-warning="showWarning = false"
      @go-to-dashboard="goToDashboard()"
    />
  </div>
</template>
<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import ConfirmACHPayment from './components/ConfirmACHPayment/ConfirmACHPayment.vue';
import ConfirmDirectBillPayment from './components/ConfirmDirectBillPayment/ConfirmDirectBillPayment.vue';
import WarningDialog from './components/WarningDialog/WarningDialog.vue';
import { mapActions, mapState } from 'pinia';
import { useChildRiderStore } from '../../store/childrider.store';
import { RouteNames } from '@/router/routeNames';

const componentOptions: ComponentOptions = {
  name: 'CRCStepC',
  components: {
    ConfirmACHPayment,
    ConfirmDirectBillPayment,
    WarningDialog,
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  data: () => ({
    showWarning: false,
  }),
  computed: {
    ...mapState(useChildRiderStore, {
      selectedPackage: 'NPPackage',
    }),
    isB2BillingForm() {
      return this.selectedPackage?.paymentForm === 'B2';
    },
    isA1orC2orD2BillingForm() {
      return (
        this.selectedPackage.paymentForm === 'A1' ||
        this.selectedPackage.paymentForm === 'C2' ||
        this.selectedPackage.paymentForm === 'D2' ||
        this.selectedPackage.paymentForm === 'H1'
      );
    },
  },
  methods: {
    ...mapActions(useChildRiderStore, {
      crcCancel: 'crcCancel',
      crcNext: 'crcNext',
    }),
    setDisplayWarning() {
      this.showWarning = true;
    },
    next() {
      this.crcNext({ paymentInfo: 'paymentInfo' });
    },
    async goToDashboard() {
      this.crcCancel();
      await this.$router.push({ name: RouteNames.DASHBOARD });
    },
  },
};

export default defineComponent(componentOptions);
</script>
